import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { AppNodeOf } from '../../types';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { IF_SOURCE_HANDLES } from '../ifHandles';
import { CardShell } from '../CardShell';

export const IfNodeView = memo(function IfNodeView({ data }: NodeProps<AppNodeOf<'if'>>) {
  const displayLanguage = useFlowDisplayLanguage();
  const summary = `${data.operator} ${data.compareValue || '—'}`;

  return (
    <CardShell
      kind="if"
      accent="amber"
      title={getNodeDisplayLabel('if', displayLanguage)}
      summary={summary}
    >
      <div className="flow-node__port-label flow-node__port-label--in text-amber-700" style={{ top: '50%', transform: 'translateY(-50%)' }}>
        {displayLanguage === 'en' ? 'input' : '入力'}
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-amber-700" style={{ top: '30%', transform: 'translateY(-50%)' }}>
        true
      </div>
      <div className="flow-node__port-label flow-node__port-label--out text-amber-700" style={{ top: '70%', transform: 'translateY(-50%)' }}>
        false
      </div>

      <Handle type="target" position={Position.Left} style={{ top: '50%' }} className="!bg-amber-500" />
      <Handle
        id={IF_SOURCE_HANDLES.true}
        type="source"
        position={Position.Right}
        style={{ top: '30%' }}
        className="!bg-amber-500"
      />
      <Handle
        id={IF_SOURCE_HANDLES.false}
        type="source"
        position={Position.Right}
        style={{ top: '70%' }}
        className="!bg-amber-500"
      />
    </CardShell>
  );
});
